import { useTranslation } from 'react-i18next';

const testimonials = [
  { quote: 'quote1', name: 'name1', role: 'role1' },
  { quote: 'quote2', name: 'name2', role: 'role2' },
  { quote: 'quote3', name: 'name3', role: 'role3' },
];

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wide">
            {t('testimonials.tag')}
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {t('testimonials.title')}
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-600">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((item) => (
            <figure
              key={item.quote}
              className="rounded-lg border border-background-200 bg-white p-6 flex flex-col"
            >
              <div className="text-accent-500 text-lg mb-3">
                <i className="ri-double-quotes-l"></i>
              </div>
              <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
                {t(`testimonials.${item.quote}`)}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-background-200">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading font-bold">
                  {t(`testimonials.${item.name}`).charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {t(`testimonials.${item.name}`)}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {t(`testimonials.${item.role}`)}
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}